var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Card, Text } from '@philips-internal/oswald-ui-components/lib/components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { MessageService, ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID, isFunction } from '@philips-internal/oswald-ui-utils';
import React, { Component } from 'react';
import { ReactComponent as AboveReferenceValueLegend } from '../../assets/images/global/above-reference-value.svg';
import { ReactComponent as BellowReferenceValueLegend } from '../../assets/images/global/bellow-reference-value.svg';
import { ReactComponent as ViewReportLegend } from '../../assets/images/global/download-round.svg';
import DownloadIcon from '../../assets/images/global/download.svg';
import ExamCardAPI from './exam-card-api';
import './exam-card.css';
let ExamCard = class ExamCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { dsExame, dsResultado, dsUnidMedida, dsValorRefMax, dsValorRefMin, dtResultado, ieCritico, ieFormatoTexto, nrPrescricao, nrSeqResultado, nrSequencia, onClick } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        dsExame,
                        dsResultado,
                        dsUnidMedida,
                        dsValorRefMax,
                        dsValorRefMin,
                        dtResultado,
                        ieCritico,
                        ieFormatoTexto,
                        nrPrescricao,
                        nrSeqResultado,
                        nrSequencia,
                    }
                }));
            }
        };
        this.colorClasses = {
            above_reference_value: {
                badge: 'c-exam-card-content-dsresultado-badge-above-reference-value',
                margin: 'c-exam-card-above-reference-value',
            },
            bellow_reference_value: {
                badge: 'c-exam-card-content-dsresultado-badge-bellow-reference-value',
                margin: 'c-exam-card-bellow-reference-value',
            },
            between_reference_value: {
                badge: 'c-exam-card-content-dsresultado-badge-between-reference-value',
                margin: 'c-exam-card-between-reference-value',
            },
            critical_result: {
                badge: 'c-exam-card-content-dsresultado-badge-critical-result',
                margin: 'c-exam-card-critical-result',
            },
            no_reference_value: {
                badge: 'c-exam-card-content-dsresultado-badge-no-reference-value',
                margin: 'c-exam-card-no-reference-value',
            },
            view_report: {
                badge: 'c-exam-card-content-dsresultado-badge-view-report',
                margin: 'c-exam-card-view-report',
            }
        };
        this.getColor = (result, minRef, maxRef, ieCritico) => {
            if (result) {
                result = result.replace(',', '.');
                result = parseFloat(result);
                maxRef = maxRef.replace(',', '.');
                minRef = minRef.replace(',', '.');
            }
            if (result != undefined && !isNaN(result)) {
                if (ieCritico === 'S') {
                    return this.colorClasses.critical_result;
                }
                if (result >= minRef && result <= maxRef) {
                    return this.colorClasses.between_reference_value;
                }
                if (result > maxRef) {
                    return this.colorClasses.above_reference_value;
                }
                if (result < minRef) {
                    return this.colorClasses.bellow_reference_value;
                }
                return this.colorClasses.no_reference_value;
            }
            return this.colorClasses.view_report;
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    renderData(badgeColor) {
        const { dsExame, dtResultado, dsUnidMedida, dsResultado, } = this.props;
        let res = dsResultado;
        if (dsResultado) {
            res = dsResultado.replace(',', '.');
            res = parseFloat(res);
            if (!isNaN(res)) {
                res = ModelService.format('numeric', res, {});
            }
            else {
                res = dsResultado;
            }
        }
        return (React.createElement("div", { className: 'c-exam-card-content-item' },
            React.createElement("div", { className: 'c-exame-card-content-dsexame' },
                React.createElement(Text, { className: "c-title-value", value: dsExame }),
                React.createElement(Text, { className: "c-text-value", value: dtResultado }),
                dsUnidMedida && React.createElement(Text, { className: "c-text-value", value: dsUnidMedida })),
            React.createElement("div", { className: 'c-exam-card-content-dsresultado' },
                dsResultado &&
                    React.createElement("button", { className: 'c-exam-card-content-dsresultado-badge ' + (badgeColor) }, res),
                !dsResultado &&
                    React.createElement("div", null,
                        React.createElement("div", { className: 'dot' },
                            React.createElement("img", { src: DownloadIcon, width: "20px", height: "20px" }))))));
    }
    render() {
        const { dsResultado, dsValorRefMax, dsValorRefMin, ieCritico, nrPrescricao } = this.props;
        const color = this.getColor(dsResultado, dsValorRefMin, dsValorRefMax, ieCritico);
        const legends = [
            {
                color: 'signal-blue-50',
                icon: React.createElement(ViewReportLegend, null),
                label: MessageService.translate('tws.view-report'),
                value: MessageService.translate('tws.view-report')
            },
            {
                color: 'signal-gray-30',
                label: MessageService.translate('tws.label-no-reference-value'),
                value: MessageService.translate('tws.label-no-reference-value')
            },
            {
                color: 'signal-red-60',
                label: MessageService.translate('tws.label-critical-result'),
                value: MessageService.translate('tws.label-critical-result')
            },
            {
                color: 'signal-pink-30',
                icon: React.createElement(AboveReferenceValueLegend, null),
                label: MessageService.translate('tws.label-max-value'),
                value: MessageService.translate('tws.label-max-value')
            },
            {
                color: 'signal-yellow-45',
                icon: React.createElement(BellowReferenceValueLegend, null),
                label: MessageService.translate('tws.label.min-value'),
                value: MessageService.translate('tws.label.min-value')
            }
        ];
        return (React.createElement(Card, { className: `c-exam-card ${color.margin}`, selectionType: SelectionType.SINGLE, key: nrPrescricao, superscription: legends, width: 12, onClick: () => this.handleClick(), uuid: generateUUID() },
            React.createElement("div", { className: 'c-exam-card__wrapper' }, this.renderData(color.badge))));
    }
};
ExamCard = __decorate([
    AwesomeComponent({ api: ExamCardAPI, type: ComponentType.DATA_DISPLAY })
], ExamCard);
export default ExamCard;
//# sourceMappingURL=exam-card.js.map